import Handsontable from 'handsontable';

export function addColumns(x: Handsontable, indexes: number[]) {
  indexes.forEach(diffIndex => {
    x.alter('insert_col', diffIndex, 1);
  });
}
